import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service'
import { ConfigService } from './config.service';
import { UpdatePasswordRequestDto, UserDto } from './user.dto';

const API_EXT = '/user/'

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private configService: ConfigService

  ) { }

  private get api_url(): string {
    const base = this.configService.getApiBaseUrl(); // OK si config chargée
    return base + API_EXT;
  }

  me(): Observable<UserDto> {
    return this.http.get<UserDto>(
      this.api_url + 'me',
      this.httpService.httpOptions
    );
  }

  update_password(request: UpdatePasswordRequestDto): Observable<void> {

    return this.http.post<void>(
      this.api_url + 'me/update-password',
      request,
      this.httpService.httpOptions
    );
  }

  update_consent(){
    const data = {}
    return this.http.post<void>(
      this.api_url + 'me/accept-agreement',
      data,
      this.httpService.httpOptions
    );
  }


}
